import {
    additionalField,
    additionalFieldTranslations,
    events,
    eventTranslations,
    locations,
    locationTranslations,
    units,
    unitTranslations
} from "../API/types";
import { htmlEntityDecode } from "../../../Utils/String";

export class I18n {
    /**
     * obtain translations from dom
     */
    public get translations(): typeof window.sbi18n {
        return window.sbi18n || { events: {}, additional_fields: {}, locations: {}, units: {} };
    }

    public getEvents(v: events) {
        return v.reduce((acc, cur) => {
            acc[cur.id] = {
                name: htmlEntityDecode(this.translations.events?.[cur.id]?.name) || cur.name,
                description: htmlEntityDecode(this.translations.events?.[cur.id]?.description) || cur.description
            };
            return acc;
        }, {} as eventTranslations);
    }

    public getLocations(v: locations) {
        return v.reduce((acc, cur) => {
            acc[cur.id] = {
                title: htmlEntityDecode(this.translations.locations?.[cur.id]?.title) || cur.title,
                name: htmlEntityDecode(this.translations.locations?.[cur.id]?.name) || cur.name,
                description: htmlEntityDecode(this.translations.locations?.[cur.id]?.description) || cur.description
            };
            return acc;
        }, {} as locationTranslations);
    }

    public getUnits(v: units) {
        return v.reduce((acc, cur) => {
            acc[cur.id] = {
                name: htmlEntityDecode(this.translations.units?.[cur.id]?.name) || cur.name,
                description: htmlEntityDecode(this.translations.units?.[cur.id]?.description) || cur.description
            };
            return acc;
        }, {} as unitTranslations);
    }

    public getAdditionalFields(v: additionalField[]) {
        return v.reduce((acc, cur) => {
            acc[cur.id] = {
                title: htmlEntityDecode(this.translations.additional_fields?.[cur.id]?.title) || cur.title,
                value: htmlEntityDecode(this.translations.additional_fields?.[cur.id]?.value) || cur.value,
                values: htmlEntityDecode(this.translations.additional_fields?.[cur.id]?.values) || cur.values,
                default: htmlEntityDecode(this.translations.additional_fields?.[cur.id]?.default) || cur.default
            };
            return acc;
        }, {} as additionalFieldTranslations);
    }
}
